import React, { FC, Fragment, useState } from 'react';
import CustomCarouselDots from '../../@shared/customCarouselDots';
import HeroCarouselCounterIndicator from './heroCarouselCounterIndicator';
import HeroCarouselScrollSymbol from './heroCarouselScrollSymbol';
import { Carousel as ReactResponsiveCarousel } from 'react-responsive-carousel';
import HeroCarouselSlide from './heroCarouselSlide';
import { THeroBannerCarousel } from '../types/herocarousel.types';
import Icon from '../../@shared/icon';
import { iconSize } from '../../../constants/icon.constants';

const HeroBannerCarousel: FC<THeroBannerCarousel> = (props) => {
  const { dataSource, carouselSlide, headingTag, showCauroselOverlay, isEE, rendering, sitecoreContext } = props;
  const interval = 10000; // when you change this change also the $interval variable in HeroCarousel > style.scss
  const hasMultipleSlides = carouselSlide?.length > 1;

  const [currentSlide, _setCurrentSlide] = useState(0);

  const goNext = (): void => (currentSlide === carouselSlide.length - 1 ? setCurrentSlide(0) : setCurrentSlide(currentSlide + 1));
  const goPrevious = (): void => (currentSlide === 0 ? setCurrentSlide(carouselSlide.length - 1) : setCurrentSlide(currentSlide - 1));


  const setCurrentSlide = (index: number): void => {
    if (hasMultipleSlides && currentSlide !== index) {
      _setCurrentSlide(index);
    }
  };
  return (
    <Fragment>
      {dataSource ? (
        <>
          <div className="carousel-inner-wrapper">
            <ReactResponsiveCarousel
              infiniteLoop={!isEE}
              interval={interval}
              autoPlay={true}
              onChange={setCurrentSlide}
              selectedItem={currentSlide}
              showThumbs={false}
              showArrows={false}
              showIndicators={false}
              showStatus={false}
              stopOnHover={false}
              preventMovementUntilSwipeScrollTolerance
              swipeScrollTolerance={100}
            >
              {carouselSlide?.map((itemFields, index) => {
                const slideInfo = { currentSlide, index };
                return (
                  <HeroCarouselSlide
                    key={itemFields?.title?.value}
                    slideInfo={slideInfo}
                    fields={itemFields}
                    rendering={rendering}
                    isEEActive={isEE}
                    sitecoreContext={sitecoreContext}
                    slideTitleTag={headingTag}
                  />
                );
              })}
            </ReactResponsiveCarousel>

            {showCauroselOverlay && <HeroCarouselScrollSymbol />}

            {hasMultipleSlides && (
              <div className={'controls'}>
                <div className="controls__arrows" onClick={goPrevious}>
                  <Icon iconName="arrow-chevron-left" color="white" size={iconSize.md} />
                </div>
                {
                  <CustomCarouselDots
                    cardsCount={(carouselSlide || []).length}
                    activeCard={currentSlide + 1}
                    hasAnimation={true}
                    isDarkMode={true}
                  />

                }
                <div className="controls__arrows" onClick={goNext}>
                  <Icon iconName="arrow-chevron-right" color="white" size={iconSize.md} />
                </div>
              </div>
            )}

            {showCauroselOverlay &&
              hasMultipleSlides &&
              carouselSlide?.map((_, i) => (
                <HeroCarouselCounterIndicator
                  baseClassName={'controls__counter'}
                  key={'control' + _?.title?.value}
                  isSelected={i === currentSlide}
                />
              ))}
          </div>
        </>
      ) : null}
    </Fragment>
  );
};

export default HeroBannerCarousel;
